export default __webpack_public_path__ + "static/media/Lamentatus.25ef92ca.jpg";